import { Table } from 'antd';
import { styled } from 'styled-components';

export const Wrapper = styled.div`
  overflow: auto;
  width: 100%;
`;

export const TableTitle = styled.div`
  font-size: 25px;
  font-weight: 600;
  padding: 10px 20px 20px 10px;
  color: #333;
`;

export const TableTopSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const TableTopButtonSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const AddButton = styled.button`
  width: 110px;
  background-color: #40a0fb;
  color: white;
  border: none;
  border-radius: 20px;
  padding: 10px 20px;
  cursor: pointer;
  outline: none;
  margin-bottom: 15px;
  margin-right: 10px;
  &:hover {
    background-color: #0056b3;
  }
`;

export const MobileListButton = styled.button`
  width: 110px;
  background-color:rgb(23, 73, 129);
  color: white;
  border: none;
  border-radius: 20px;
  padding: 10px 20px;
  cursor: pointer;
  outline: none;
  margin-bottom: 15px;
  &:hover {
    background-color:rgb(68, 108, 187);
  }
`;

export const AddContainer = styled.div`
  display: flex;
  justify-content: end;
  width: 100%;
`;

export const InputField = styled.input`
  width: 100%;
  padding: 10px;
  margin-bottom: 15px;
  border: 1px solid #ccc;
  border-radius: 5px;
`;

export const SelectField = styled.select`
  width: 100%;
  padding: 10px 15px 10px 10px;
  margin-bottom: 15px;
  border: 1px solid #ccc;
  border-radius: 5px;
`;

export const SelectOption = styled.option`
  background-color: white;
`;

export const CheckboxGroup = styled.div``;

export const CustomStyledTable = styled(Table)`
  .ant-table {
    font-size: 12px;
    height: 100%;
    border-radius: 10px;
    overflow: hidden;
    border: 1px solid #e8e8e8;
  }

  .ant-table-tbody > tr > td {
    padding: 7px 15px;
    text-align: center;
    vertical-align: middle;
    text-align: left;
    background-color: white;
  }

  .ant-table-thead > tr > th {
    padding: 7px 15px;
  }

  .ant-table-column-title {
    width: 100%;
    padding: 7px;
    vertical-align: middle;
  }
`;


export const FilterSection = styled.div`
  margin: 16px 0;
  display: flex;
  flex-direction: row;
  align-items: center;
`;